<template>
  <div class="tw-w-screen tw-bg-white tw-py-10   ">

    <div class="tab-view-container tw-w-full tw-flex tw-flex-col" :class="{ 'animate-slide-up': isVisible }">
      <div class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center">
        <span class="tw-text-textMain tw-text-xl tw-font-bold tw-mb-4 " v-html="$t('服务优势')"></span>
      </div>


      <div class="tw-w-full tw-flextw-gap-12 tw-mt-6 tw-px-4">
        <div v-for="(item, index) in features" :key="index" class="tw-flex tw-flex-col tw-mb-6">
          <img :src="item.iconUrl" alt="" class="tw-w-12 tw-h-12">
          <div class="tw-flex tw-flex-col tw-mt-3">
            <span class="tw-text-textMain tw-text-base tw-font-bold tw-mb-2 ">{{ $t(item.title) }}</span>
            <span class="tw-text-textDisabled tw-text-sm  ">{{ $t(item.desc) }}</span>
          </div>
        </div>

      </div>


    </div>

  </div>
</template>

<script>
export default {
  name: 'mobilePlatformView',
  data() {
    return {
      isVisible: false,
      observer: null,
      features: [
        {
          iconUrl: '/icons/icon_woshou.png',
          title: '介绍标题1',
          desc: '介绍内容1',
        },
        {
          iconUrl: '/icons/icon_web3.png',
          title: '介绍标题2',
          desc: '介绍内容2',
        },
        {
          iconUrl: '/icons/icon_hegui.png',
          title: '介绍标题3',
          desc: '介绍内容3',
        },
        {
          iconUrl: '/icons/icon_paihang.png',
          title: '介绍标题4',
          desc: '介绍内容4',
        },
        {
          iconUrl: '/icons/icon_renshu.png',
          title: '介绍标题5',
          desc: '介绍内容5',
        },
        {
          iconUrl: '/icons/icon_jiaoyi.png',
          title: '介绍标题6',
          desc: '介绍内容6',
        }
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  methods: {
    initIntersectionObserver() {

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isVisible) {
            this.isVisible = true;
            // 动画只执行一次，所以可以断开观察器
            this.observer.disconnect();
          }
        });
      }, {
        threshold: 0, // 当组件10%可见时触发
      });

      this.observer.observe(this.$el);
    },
  }
};
</script>

<style scoped lang="scss">
.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}

.main {
  display: flex;
}

.left-image {
  width: 30%;
  background-image: url('@/assets/home/Rectangle_4160@2x.png');
  /* 请替换为实际图片地址 */
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  position: relative;
}

.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  margin: 10px;
  border-radius: 5px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.46) 0%, #FFFFFF 63%);
}

.right-content {
  width: 68%;
  margin-left: 2%;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-around;
  padding-left: 20px;
}

.feature-item {
  padding: 15px 20px;
  width: 33%;
  // margin-bottom: 20px;
}

.feature-icon {
  width: 110px;
  height: 110px;
  margin: 0 auto 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.feature-title {
  font-size: 16px;
  margin-bottom: 10px;
  text-align: center;
}

.feature-desc {
  font-size: 14px;
  color: #666;
}

.border-right {
  border-right: 1px solid #EBEBEB;
}

.border-bottom {
  border-bottom: 1px solid #EBEBEB;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;

  h4 {
    color: #4077F8;
  }
}

.mr-40 {
  margin-right: 40px;
}
</style>
